import { SPECIFICATION_SET_CURRENT_SPECIFICATIONS } from '../constants';

const defaultState = {
  specifications: [],
};

export const specification = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SPECIFICATION_SET_CURRENT_SPECIFICATIONS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
